if (!window.debug) {
	window.debug = function (name) {
		return function () {
			console.log(name, ...arguments)
		}
	}
}

export const log = debug('vvvumeter:main')